import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { Formik, Form } from "formik";
import { LatLngLiteral } from "leaflet";
import React from "react";
import { Input } from "../../../components/Input/Input";
import { useSaveGeofenceModal } from "../hooks/useSaveGeofenceModal";

interface SaveGeofenceModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  geofence?: LatLngLiteral[];
  handleSubmit: (values: { name: string }) => void;
  handleClose: () => void;
}

export const SaveGeofenceModal: React.FC<SaveGeofenceModalProps> = ({
  isOpen,
  isLoading = false,
  geofence,
  handleSubmit,
  handleClose,
}) => {
  const { t, initialValues, validationSchema } = useSaveGeofenceModal(geofence);

  return (
    <Modal
      closeOnOverlayClick={false}
      size="md"
      isCentered
      isOpen={isOpen}
      onClose={handleClose}
    >
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
      <ModalContent>
        <ModalHeader color="newBlue.500">{t("saveArea")}</ModalHeader>
        <ModalCloseButton color="black" />
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values, errors, touched, handleChange, submitForm }) => (
            <Form noValidate>
              <ModalBody color="gray.500">
                <FormControl
                  isRequired
                  isInvalid={!!errors.name && touched.name}
                >
                  <FormLabel color="#414651" fontWeight="500">
                    {t("areaName")}
                  </FormLabel>
                  <Input
                    name="name"
                    placeholder={t("areaNamePlaceholder") as string}
                    value={values.name}
                    onChange={handleChange}
                    maxLength={70}
                    autoFocus
                  />
                  <FormErrorMessage mt={4}>{errors.name}</FormErrorMessage>
                </FormControl>
              </ModalBody>

              <ModalFooter>
                <Button
                  variant="ghost"
                  color="newBlue.500"
                  onClick={handleClose}
                  mr={3}
                  isDisabled={isLoading}
                >
                  {t("cancel")}
                </Button>
                <Button
                  layerStyle="ocean"
                  _hover={{ layerStyle: "ocean" }}
                  onClick={submitForm}
                  type="submit"
                  isLoading={isLoading}
                  loadingText={t("save") as string}
                >
                  {t("save")}
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  );
};
